import { useMemo } from 'react'

import { useBreakpoint } from '@/hooks/useBreakpoint'

/**
 * Returns a style object to constrain bottom sheets to 50% width on widescreen.
 * Use with BottomSheetModal's style prop for consistent UX across the app.
 */
const useWidescreenBottomSheetStyle = () => {
  const { isLargeAndUp } = useBreakpoint()

  return useMemo(
    () => (isLargeAndUp ? { marginHorizontal: '25%' as const } : undefined),
    [isLargeAndUp]
  )
}

export default useWidescreenBottomSheetStyle
